import React, { type JSX } from 'react'
import { Padlock, PadlockSmall, PadlockBold } from '@zuto/icons'
import { styled } from '@mui/material'
import { muiTypography } from '@zuto/theme/src/mui/DefaultTheme'

type SecureDataIconProps = {
  title?: string
  variant?: 'normal' | 'small' | 'bold'
  flexDirection?: 'row' | 'column'
  alignItems?: 'flex-start' | 'flex-end' | 'center'
  marginRight?: string
}

const SecureDataWrapper = styled('div')({})
const SecureDataTitle = styled('div')({})

const styles = {
  wrapper: {
    display: 'flex'
  },
  title: {
    ...muiTypography.body.text.normal,
    paddingLeft: '12px',
    '&.text-small': {
      ...muiTypography.body.text.small,
      paddingLeft: 0
    }
  }
}

const renderLock = (variant: string) => {
  let icon: JSX.Element
  switch (variant) {
    case ('normal'):
      icon = <Padlock data-testid="padlock-normal" />
      break
    case ('small'):
      icon = <PadlockSmall data-testid="padlock-small" />
      break
    case ('bold'):
      icon = <PadlockBold data-testid="padlock-bold" />
      break
    default:
      icon = <PadlockSmall data-testid="padlock-small" />
      break
  }
  return icon
}


export const SecureDataIcon = ({
  title = 'Secure',
  variant = 'normal',
  flexDirection = 'row',
  alignItems = 'flex-start',
  marginRight
}: SecureDataIconProps) => (
  <SecureDataWrapper
    sx={{
      ...styles.wrapper, marginRight, flexDirection, alignItems
    }}
  >
    {renderLock(variant)}
    <SecureDataTitle sx={styles.title} className={variant === 'normal' ? '' : 'text-small'} data-testid="secure-data-icon">{title}</SecureDataTitle>
  </SecureDataWrapper>
)
